import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error(
        'Missing Supabase env. Check VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY'
    );
}

export const supabase: SupabaseClient = createClient(
    supabaseUrl,
    supabaseAnonKey
);